import { render, staticRenderFns } from "./TermoAutorizacaoEntrada.vue?vue&type=template&id=136010d0&"
import script from "./TermoAutorizacaoEntrada.vue?vue&type=script&lang=js&"
export * from "./TermoAutorizacaoEntrada.vue?vue&type=script&lang=js&"
import style0 from "./TermoAutorizacaoEntrada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports